import { AppointmentBookScheduleRequest } from '../models/AppointmentBookScheduleRequest';
import { AppointmentBookApi } from '../services/api';
import { ResponseAPI } from './responseApi';
import { SystemUnavailableError } from '../errors';
import { AppointmentBookSlot } from '../models/AppointmentBookSlots';

export const saveSchedule = async (props: AppointmentBookScheduleRequest) => {
  const result: ResponseAPI<any> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as any
  };

  try {
    const response = await AppointmentBookApi.post('v2/schedule', props);

    result.data = response?.data;
    return result;
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};

export type Service = {
  attendanceType: string;
  description: string;
  id: number;
  isTelemedicine: false;
  unitId: string;
};

export const fetchServicesBySpecialistAndOffice = async (props: {
  specialistId: number;
  officeId: string;
  channel: string;
}) => {
  const result: ResponseAPI<Service[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Service[]
  };

  try {
    const response = await AppointmentBookApi.get(
      `v2/services/specialists/${props.specialistId}/offices/${props.officeId}/channel/${props.channel}`
    );

    result.data = response?.data?.services;
    return result;
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};

type Payment = {
  id: string;
  description: string;
  isHealthInsurance: boolean;
  planId: string;
};

export const fetchPaymentsBySpecialistAndOffice = async (props: {
  specialistId: string;
  officeId: string;
  channel: string;
  subgroup: string;
}) => {
  const result: ResponseAPI<Payment[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as Payment[]
  };

  try {
    const response = await AppointmentBookApi.get(
      `v2/payments/specialists/${props.specialistId}/offices/${props.officeId}/channel/${props.channel}/`,
      { params: { subgroup: props.subgroup } }
    );

    result.data = response?.data?.paymentsMethods;
    return result;
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};

export type Appointments = {
  id: number;
  status: string;
  date: string;
  selectedDate?: string;
  selectedHour?: string;
  duration: number;
  resourceConfigId: string;
  scheduleExternalId: null;
  observations: string;
  paymentTypeId: number;
  sessionId?: null;
  patient: {
    id: number;
    firstName: string;
    lastName: string;
    sex: string;
    birthDate: string;
    document: string;
    documentType: string;
    email: string;
    externalId: null;
    phone: string;
    ddi: string;
    age: number;
  };
  unit: {
    name: string;
    address: string;
    number: null;
    complement: null;
    neighborhood: null;
    city: null;
    state: null;
    postalCode: null;
    latitude: null;
    longitude: null;
    phone: null;
    externalId: string;
  };
  payment: [
    {
      healthInsuranceId: string;
      healthInsuranceName: null;
      cardNumber: null;
      planCode: null;
      planName: null;
      price: null;
    }
  ];
  service: {
    id: number;
    name: string;
    attendanceTypeId: number;
    attendanceType: {
      id: number;
      name: string;
    };
  };
  resource: {
    id: number;
    name: string;
    externalId: string;
    catalogId?: string;
    specialties: [
      {
        id: number;
        name: string;
        resourceId: number;
      }
    ];
  };
  appointmentUrl?: string;
  verifier: string;
  ternalId?: string;
};

export const fetchAppointments = async (params: {
  patientDocument: string;
  startDate: string;
  finishDate?: string;
}) => {
  try {
    const response = await AppointmentBookApi.get('api/schedules', { params });

    return response?.data?.schedules as Appointments[];
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};

export type WaitingListProps = {
  fullName: string; //'Teste Care Plus';
  email: string; //'teste.careplus@example.com';
  phone: string; //'90921231319';
  catalogUnitId: string; //'31232';
  catalogUnitName: string; //'Morumbi';
  catalogSpecialityId: string; //'21312312';
  catalogSpecialtyDescription: string; //'Endocrinologia';
  isDeleted: false;
  deletedBy: null;
  document: string;
  documentType: string;
};

export const sendToWaitingList = async (body: WaitingListProps) => {
  const result: ResponseAPI<any[]> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as any[]
  };

  try {
    const response = await AppointmentBookApi.post('v2/waitingList', body);

    result.data = response?.data;
    return result;
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};

type FetchSlotsProps = {
  userId: string;
  catalogUnitId: string;
  catalogSpecialtyId: string;
  interval: number;
  startDate: string;
  service: string;
  appointmentType: string;
};

export const fetchSlots = async (params: FetchSlotsProps) => {
  try {
    const response = await AppointmentBookApi.get('v2/slots', { params });

    return response?.data as AppointmentBookSlot[];
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};

type RescheduleProps = {
  date: string;
  hour: string;
};

export const saveReschedule = async (id: number, bodyParams: RescheduleProps) => {
  try {
    const response = await AppointmentBookApi.patch(
      `/v2/schedules/${id}/schedule-details/channel/care-plus`,
      bodyParams
    );

    return response?.data as AppointmentBookSlot[];
  } catch (error: any) {
    throw new SystemUnavailableError(error.message);
  }
};
